import React from "react";
import "./SpeedFooter.css";
import Logo from "../Logo/SPEEDLOGO.png"; // ya png use karo

const SpeedFooter: React.FC = () => {
  return (
    <footer className="custom-footer">
      <div className="footer-container">
        {/* ===== COLUMN 1 ===== */}
        <div className="footer-col">
          <img src={Logo} alt="Courier Addaa" className="footer-logo" />
          <p>
            <strong> Speed Logistics </strong> is the fastest, most reliable,
            full service, time-critical courier company with products ranging
            from door-to-door and “Next flight available” Air services to
            Airfreight, messenger, same day Delivery.
          </p>
        </div>

        {/* ===== COLUMN 2 ===== */}
        <div className="footer-col">
          <h5>Our Divisions</h5>
          <ul>
            <li>What We Do</li>
            <li>Request a Freight</li>
            <li>Track & Trace</li>
            <li>About Us</li>
            <li>Package Plan</li>
          </ul>
        </div>

        {/* ===== COLUMN 3 ===== */}
        <div className="footer-col">
          <h5>Our Services</h5>
          <ul>
            <li>Road Freight</li>
            <li>Drone Freight</li>
            <li>Ocean Freight</li>
            <li>Rail Freight</li>
            <li>Air Freight</li>
          </ul>
        </div>

        {/* ===== COLUMN 4 ===== */}
        <div className="footer-col">
          <h5>Industry Sectors</h5>
          <ul>
            <li>What We Do</li>
            <li>Request a Freight</li>
            <li>Track & Trace</li>
            <li>Our Team</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* ===== COLUMN 5 ===== */}
        <div className="footer-col">
          <h5>Get in Touch</h5>
          <p>
            <i className="fas fa-map-marker-alt"></i>
            Gala No.18,Mistry Industrial Estate MIDC,Behind Tunga Hotel
            International Hotel, Andheri East,Mumbai 400093
          </p>
          <p>
            <i className="fas fa-phone-alt"></i> +91 9323492148 / 9702907289
          </p>
          <p>
            <i className="far fa-envelope"></i>{" "}
            <a href="mailto:cs@speedlogisticsindia.com">
              cs@speedlogisticsindia.com
            </a>
          </p>
        </div>
      </div>

      {/* ===== COPYRIGHT STRIP ===== */}
      <div className="footer-bottom">
        <p>© 2025 Speed Logistics| All rights reserved</p>

        <span>
          Powered by{" "}
          <a href="https://www.neotechnet.com" target="_blank" rel="noreferrer">
            Neotech IT Services
          </a>
        </span>

        <div className="footer-social">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-facebook-f"></i>
          </a>
          <a href="https://x.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-x-twitter"></i>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-instagram"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-youtube"></i>
          </a>
          <a href="https://wa.me/9702907289" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default SpeedFooter;
